/**
 * Report attribution.
 *
 * Reports are attributed to the Dupe Research Team -- the real, accountable
 * entity behind them (AI research agents + human review) -- never to invented
 * persona authors. Fabricated author profiles with AI-generated photos and
 * credentials are an explicit deception trigger in Google's Quality Rater
 * Guidelines (4.5.3) and were removed in June 2026. Do not reintroduce
 * fictional bylines. The team is described in full at /deepresearch/team.
 */

export interface ResearchAuthor {
  slug: string
  name: string
  jobTitle: string
  bio: string
  /** Absolute URL to the author page describing who/how research is done. */
  url: string
  /** Absolute URL to the byline avatar, served from ImageKit. */
  avatarUrl: string
}

export const RESEARCH_TEAM_PATH = '/deepresearch/team'
/** Standalone methodology page describing the research pipeline in depth. */
export const RESEARCH_METHODS_PATH = '/deepresearch/methodology'

const RESEARCH_TEAM_AUTHOR: ResearchAuthor = {
  slug: 'dupe-research-team',
  name: 'Dupe Research Team',
  jobTitle: 'Research & Editorial Team',
  bio: 'Dupe pairs AI research agents with human review: our agents aggregate retailer specs, pricing, and thousands of owner reviews, and the Dupe team reviews the findings and selects the top picks.',
  url: `https://dupe.com${RESEARCH_TEAM_PATH}`,
  // The Dupe "%" logo (self-hosted). Never an AI-generated portrait -- the
  // team byline must not look like a person who does not exist.
  avatarUrl: 'https://dupe.com/android-chrome-512x512.png',
}

export function getResearchAuthor(
  _categorySlug?: string | null | undefined
): ResearchAuthor {
  return RESEARCH_TEAM_AUTHOR
}

export function getAllResearchAuthors(): ResearchAuthor[] {
  return [RESEARCH_TEAM_AUTHOR]
}
